import {GetFooterDynamicResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {useCanGoBack, useCurrentPageType} from '@aboutyou/router';
import {LinkSections, StreamSeoText} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {FooterLayoutAreas, FooterLayoutSlot} from '../FooterLayout';
import {mapSectionToEntry} from '../utils/footerNormalizers';

export interface FooterDynamicViewProps {
  hideCategories?: boolean;
}

export const FooterDynamicView: React.FC<
  GetFooterDynamicResponse & FooterDynamicViewProps
> = ({footer, hideCategories = false}) => {
  const sections = mapSectionToEntry(footer.linksSections);
  const canGoBack = useCanGoBack();
  const currentPageType = useCurrentPageType();

  return (
    <>
      <FooterLayoutSlot area={FooterLayoutAreas.DYNAMIC.SEO_TEXT}>
        {!hideCategories && (
          <Nav as="div">
            {footer.seoText && !canGoBack && (
              <StreamSeoText
                content={footer.seoText}
                collapseOnClient={currentPageType !== 'category'}
              />
            )}
          </Nav>
        )}
      </FooterLayoutSlot>
      <FooterLayoutSlot area={FooterLayoutAreas.DYNAMIC.SECTION_LINKS}>
        {!hideCategories && (
          <Nav>
            <StyledLinkSections linkGroups={sections} />
          </Nav>
        )}
      </FooterLayoutSlot>
    </>
  );
};

const StyledLinkSections = styled(LinkSections)`
  flex-direction: column;
  padding: 1.5rem 1.5rem 0;
`;

const Nav = styled.nav`
  width: 100%;
  max-width: 1024px;
  margin: auto;
`;
